"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var showContentsBaseTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var MAX_M = _a.MAX_M, MAX_S = _a.MAX_S, MIN_S = _a.MIN_S, cssPrefix = _a.cssPrefix;
    return ({
        showContents: (_b = {
                display: "flex",
                flexDirection: "column-reverse"
            },
            _b[MAX_M] = {},
            _b[MAX_S] = {
                flexDirection: "column"
            },
            _b),
        showContentsIcon: (_c = {},
            _c[MIN_S] = {
                width: "auto",
                height: "2rem"
            },
            _c[MAX_S] = {
                display: "none !important"
            },
            _c),
        showContentsLink: {
            width: "50%",
            display: "flex",
            alignItems: "center",
        },
        showContentsWrapper: (_d = {
                "& .material-icons": {
                    display: "inline-block",
                    verticalAlign: "middle",
                    fontSize: 30,
                    cursor: "pointer",
                },
                display: "none",
                padding: '0.5rem 0.5rem 0 1.5rem'
            },
            _d[MAX_M] = {
                display: 'flex',
                alignContent: "center",
                paddingLeft: '0',
                paddingTop: '1.25rem',
            },
            _d[MAX_S] = {
                display: 'flex',
                padding: '0.5rem'
            },
            _d.cursor = "pointer",
            _d),
        showContentsTitle: (_e = {
                fontSize: "1.375rem",
                display: "none"
            },
            _e["& ." + cssPrefix + "_step-links_step-link-icon"] = (_f = {},
                _f[MIN_S] = {
                    display: "none",
                },
                _f),
            _e[MAX_M] = {
                display: "none"
            },
            _e[MAX_S] = {
                display: "flex",
                padding: "5px 1rem",
                "& > div": {
                    flex: 1,
                    display: "flex",
                    alignItems: "center"
                },
                justifyContent: "space-between",
                alignItems: "center",
            },
            _e),
        showContentsTitleText: (_g = {
                display: "flex",
                alignItems: "center",
                flex: 1
            },
            _g[MAX_M] = {
                textAlign: "left"
            },
            _g[MAX_S] = {
                flexDirection: "column",
                fontSize: "0.875rem",
                textAlign: "center"
            },
            _g),
        showContentsTitleBreadcrumb: (_h = {
                "& > i18n-message": {
                    marginLeft: "0.5rem"
                }
            },
            _h[MAX_M] = {
                display: "flex",
                alignItems: "center",
                fontSize: "1.25rem",
            },
            _h[MAX_S] = {
                fontSize: "0.875rem",
                lineHeight: "0.25rem",
            },
            _h),
        showContentsSections: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row-reverse",
            flex: "1"
        },
    });
};
exports.default = showContentsBaseTheme;
//# sourceMappingURL=showContents.js.map